// utils/reportRoutes.js

/**
 * Construct report URL with full IDs
 * Matches route:
 * /taloyhtiokortti/:id/raportti/:templateName/:reportId/:section/:sectionId
 */
export const reportUrl = ({
    kiinteistoId,
    templateName,
    reportId,
    section = "kansisivu",
    sectionId = 0,
    subsectionId,
  }) => {

  if (!templateName) {
    throw new Error("templateName are required to build report URL");
  }

  const base = kiinteistoId
    ? `/taloyhtiokortti/${kiinteistoId}/raportti/${templateName}/${reportId}/${section}/${sectionId}`
    : `/taloyhtiokortti/raportti/${templateName}/${reportId}/${section}/${sectionId}`;

  return subsectionId ? `${base}/${subsectionId}` : base;
};